import { render, staticRenderFns } from "./PPActionLoader.vue?vue&type=template&id=705658fa&"
import script from "./PPActionLoader.vue?vue&type=script&lang=js&"
export * from "./PPActionLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports